import { type ShippingItem } from '../domain/ShippingItem'
import { formatPackageTypeLabel } from './DimensionsPresenter'

export function formatShippingItemOrigin(stopName: string) {
  return `From ${stopName}`
}

export function formatPackageDescription(
  packageType: string,
  composeCommodityDescription: string,
  commodity?: string,
  firstCommodityDescription?: string
) {
  const commodityString = commodity || ''
  return `${packageType} of ${
    firstCommodityDescription ? composeCommodityDescription : commodityString
  }`
}

export function formatPackageTypeDescription(shippingItem: ShippingItem) {
  return shippingItem.packageType
    ? formatPackageTypeLabel({
        count: Number(shippingItem.packageCount),
        category: 'items',
        description: undefined,
        packageType: shippingItem.packageType,
      })
    : 'Pallet'
}

export function formatShippingItemStopName(shippingItem: ShippingItem) {
  return shippingItem.pickupStopIndex === 0 ? 'pickup' : `Stop#${shippingItem.pickupStopIndex}`
}
